
export default {
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      expanded: false
    };
  },
  computed: {
    price () {
      const priceCriteria = this.value.find(x => x.group === 'Price');

      if (!priceCriteria) {
        return {
          percentage: 0
        };
      }

      return priceCriteria;
    },

    quality () {
      return [
        ...this.value
          .filter(
            x =>
              x.group === 'Quality criterion' && x.description !== 'Kwaliteit'
          )
          .sort((a, b) => a.description.localeCompare(b.description))
      ];
    },

    qualityTotal () {
      return this.value
        .filter(x => x.group === 'Quality criterion')
        .reduce((prev, cur) => prev + cur.percentage, 0)
        .toFixed(1)
        .replace('.0', '');
    },

    totalPercentage () {
      let total = 0;

      this.value.forEach((element) => {
        total += element.percentage;
      });

      return total;
    },

    showCritera () {
      return this.totalPercentage !== 0;
    }
  }
};
